const PlusIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='25' viewBox='0 0 16 17' fill='none'>
      <g clip-path='url(#clip0_24604_41264)'>
        <path
          d='M11.9999 9.41146H8.66659V12.7448C8.66659 13.1115 8.36659 13.4115 7.99992 13.4115C7.63325 13.4115 7.33325 13.1115 7.33325 12.7448V9.41146H3.99992C3.63325 9.41146 3.33325 9.11146 3.33325 8.74479C3.33325 8.37813 3.63325 8.07812 3.99992 8.07812H7.33325V4.74479C7.33325 4.37813 7.63325 4.07812 7.99992 4.07812C8.36659 4.07812 8.66659 4.37813 8.66659 4.74479V8.07812H11.9999C12.3666 8.07812 12.6666 8.37813 12.6666 8.74479C12.6666 9.11146 12.3666 9.41146 11.9999 9.41146Z'
          fill='#402080'
        />
      </g>
      <defs>
        <clipPath id='clip0_24604_41264'>
          <rect width='16' height='16' fill='white' transform='translate(0 0.742188)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PlusIcon
